module.exports = __webpack_public_path__ + "static/media/team-title.e259696c.png";